import { useState } from "react";
import styles from "./ExpandingFlexCard.module.scss";
import { Link } from "react-router-dom";
import { MdFavorite } from "react-icons/md";

const ExpandingFlexCard = ({ img0, img1, img2, img3, img4 }) => {
  return (
    <div className={styles.container}>
      <div className={styles.gallery}>
        <div
          className={styles["img-box"]}
          style={{
            backgroundImage: `url(${img1})`,
          }}
        >
          <h3>
            <MdFavorite style={{ fontSize: "30px", color: "#ce0000" }} />
          </h3>
        </div>
        <div
          className={styles["img-box"]}
          style={{
            // backgroundImage: `url(${require("../../assets/img-2.jpg")})`,
            backgroundImage: `url(${img2})`,
          }}
        >
          <h3>
            <MdFavorite style={{ fontSize: "30px", color: "#ce0000" }} />
          </h3>
        </div>
        <div
          className={styles["img-box"]}
          style={{
            // backgroundImage: `url(${require("../../assets/img-3.jpg")})`,
            backgroundImage: `url(${img3})`,
          }}
        >
          <h3>
            <MdFavorite style={{ fontSize: "30px", color: "#ce0000" }} />
          </h3>
        </div>
        <div
          className={styles["img-box"]}
          style={{
            // backgroundImage: `url(${require("../../assets/img-4.jpg")})`,
            backgroundImage: `url(${img4})`,
          }}
        >
          <h3>
            <MdFavorite style={{ fontSize: "30px", color: "#ce0000" }} />
          </h3>
        </div>
      </div>
    </div>
  );
};
export default ExpandingFlexCard;
